export const TOGGLE_CONTACT_ME = 'SIMULATION/TOGGLE_CONTACT_ME'

export const toggleContactMe = () => {
  return { type: TOGGLE_CONTACT_ME }
}
